import { useState, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";
import { colors, font } from "../styles/theme";
import { services } from "../data/services";
import ServiceIcon from "./ServiceIcon";

// Аккордеон услуг: клик по строке разворачивает фото + подробное описание + пункты.
// initial — номер услуги, которую открыть сразу (из ссылки «Подробнее»).
export default function ServicesAccordion({ initial }) {
  const hasInitial = services.some((s) => s.num === initial);
  const [open, setOpen] = useState(hasInitial ? initial : null);

  // Если пришли с выбранной услугой — плавно доскроллить к ней после отрисовки.
  useEffect(() => {
    if (!hasInitial) return;
    const t = setTimeout(() => {
      document.getElementById("svc-" + initial)?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 260); // ждём анимацию раскрытия аккордеона
    return () => clearTimeout(t);
  }, [initial, hasInitial]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      {services.map((svc) => (
        <Row key={svc.num} svc={svc} open={open === svc.num} onToggle={() => setOpen(open === svc.num ? null : svc.num)} />
      ))}
    </div>
  );
}

function Row({ svc, open, onToggle }) {
  return (
    <div
      id={"svc-" + svc.num}
      style={{
        border: `1px solid ${open ? colors.red : "#e6e9ee"}`,
        borderRadius: 16,
        overflow: "hidden",
        background: "#fff",
        transition: "border-color .2s",
        scrollMarginTop: 100,
      }}
    >
      <button
        onClick={onToggle}
        aria-expanded={open}
        className="acc-head"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: "22px 24px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <div
          style={{
            flex: "none",
            width: 52,
            height: 52,
            borderRadius: 13,
            background: open ? colors.red : colors.redSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background .2s",
          }}
        >
          <ServiceIcon name={svc.icon} size={26} color={open ? "#fff" : colors.red} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 11, letterSpacing: ".1em", textTransform: "uppercase", color: colors.red }}>
            {svc.num}
          </div>
          <div style={{ fontFamily: font.display, fontWeight: 600, fontSize: "clamp(18px,2.2vw,24px)", textTransform: "uppercase", color: colors.ink, lineHeight: 1.1 }}>
            {svc.name}
          </div>
        </div>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            fontFamily: font.display,
            fontWeight: 600,
            fontSize: 13,
            letterSpacing: ".05em",
            textTransform: "uppercase",
            color: open ? colors.red : "#8b96a3",
            whiteSpace: "nowrap",
          }}
        >
          <span className="acc-label">{open ? "Свернуть" : "Подробнее"}</span>
          <ChevronDown
            size={18}
            color={open ? colors.red : "#8b96a3"}
            style={{ transition: "transform .25s", transform: open ? "rotate(180deg)" : "none" }}
          />
        </span>
      </button>

      {/* контент: фото + описание */}
      <div
        style={{
          display: "grid",
          gridTemplateRows: open ? "1fr" : "0fr",
          transition: "grid-template-rows .28s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 28, padding: "4px 24px 28px" }}>
            <div style={{ flex: "1 1 360px", minWidth: "min(100%,300px)" }}>
              <img
                src={svc.image}
                alt={svc.name}
                style={{ width: "100%", height: 260, objectFit: "cover", borderRadius: 14, display: "block" }}
              />
            </div>
            <div style={{ flex: "1 1 360px", minWidth: "min(100%,300px)" }}>
              <p style={{ margin: 0, fontSize: 16, lineHeight: 1.65, color: colors.text }}>{svc.full}</p>
              <ul style={{ listStyle: "none", margin: "20px 0 0", padding: 0, display: "flex", flexDirection: "column", gap: 12 }}>
                {svc.bullets.map((b) => (
                  <li key={b} style={{ display: "flex", alignItems: "flex-start", gap: 11 }}>
                    <span
                      style={{
                        flex: "none",
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: colors.redSoft,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: 1,
                      }}
                    >
                      <Check size={15} color={colors.red} />
                    </span>
                    <span style={{ fontSize: 15, lineHeight: 1.5, color: colors.ink2 }}>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
